import Descricao from '@/components/tipografia/Descricao';

/**
 * Textos da coexistência, compartilhados pelos dois modais de cadastro de
 * WhatsApp.
 *
 * O modal dedicado só aparece quando `VITE_WHATSAPP_COEX_CONFIG_ID` está
 * configurado. Sem ele — o caso normal — o cliente entra pelo fluxo padrão e
 * pode concluir em coexistência escolhendo a conta existente na tela da Meta.
 * Por isso o aviso precisa estar também no modal padrão: as mudanças no
 * aparelho são visíveis, imediatas e não têm desfazer.
 */

export const ComoFuncionaCoexistencia = () => (
  <ul style={{ gap: '.5rem', display: 'grid' }}>
    <li>
      <Descricao>
        Seus contatos e até 180 dias de histórico de conversas são importados
        (mídias, apenas dos últimos 14 dias).
      </Descricao>
    </li>
    <li>
      <Descricao>
        Mensagens que você enviar pelo celular aparecem no chat do TeraChat, e
        o atendimento automático é pausado para você assumir a conversa.
      </Descricao>
    </li>
    <li>
      <Descricao>
        A importação começa logo após a conexão e pode levar algumas horas
        para concluir.
      </Descricao>
    </li>
  </ul>
);

export const LimitacoesCoexistencia = () => (
  <div style={{ fontSize: '0.8rem', color: 'var(--tc-color-gray-500)' }}>
    Ao conectar, a Meta desativa no aparelho as mensagens temporárias, as de
    visualização única, a localização em tempo real e as listas de transmissão.
    Todos os dispositivos vinculados (WhatsApp Web e apps para computador) são
    desconectados e precisam ser vinculados novamente. Conversas em grupo e
    chamadas continuam só no aparelho — não aparecem no TeraChat.
  </div>
);
